import { Box, Button, Collapse, useMediaQuery, useTheme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import Flex from 'components/common/Flex';
import Text from 'components/common/Text';
import { observer, useLocalStore } from 'mobx-react';
import { AppTheme } from 'styles/theme';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import useDepsContainer from 'hooks/useDepsContainer';
import { ChevronUpSvg, ChevronDownSvg } from 'assets/icons';

const Question = (props: any) => {
  const state = useLocalStore(() => ({
    in: false
  }));
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));
  const styles = useStyles({ ...props, mdDown });
  const { uiStore } = useDepsContainer();
  const { t, i18n } = useTranslation();
  const cachedT = useMemo(() => t, [t, uiStore.language]);

  return (
    <Flex>
      <Flex
        width="100%"
        py={3}
        px={1}
        mb={'1px'}
        column
        cursorPointer
        onClick={() => (state.in = !state.in)}
        bgcolor={state.in ? '#F3F4FC' : 'white'}
        className={state.in ? styles.in : ''}
      >
        <Flex width={'100%'} justifyContent={'space-between'} centerY>
          <Flex color={'#232429'} className={state.in ? styles.questionInText : styles.questionText}>
            {props.question}
          </Flex>
          <Flex center>
            <Flex color={'#232429'} fontSize={24}>
              {state.in ? <ChevronUpSvg /> : <ChevronDownSvg />}
            </Flex>
          </Flex>
        </Flex>
        <Collapse in={state.in}>
          <Flex>
            <Flex className={styles.answerText}>{props.awnser}</Flex>
          </Flex>
        </Collapse>
      </Flex>
    </Flex>
  );
};

const useStyles = makeStyles((theme: AppTheme) =>
  createStyles({
    questionText: {
      fontStyle: 'normal !important',
      fontWeight: '500 !important',
      fontSize: (props: any) => (props.mdDown ? '14px !important' : '16px !important'),
      lineHeight: (props: any) => (props.mdDown ? '20px !important' : '24px !important')
    },
    questionInText: {
      fontStyle: 'normal !important',
      fontWeight: '500 !important',
      fontSize: (props: any) => (props.mdDown ? '14px !important' : '16px !important'),
      lineHeight: (props: any) => (props.mdDown ? '20px !important' : '24px !important'),
      color: '#E85130 !important'
    },
    answerText: {
      fontStyle: 'normal !important',
      fontWeight: '300 !important',
      fontSize: (props: any) => (props.mdDown ? '14px !important' : '16px !important'),
      lineHeight: (props: any) => (props.mdDown ? '20px !important' : '24px !important'),
      color: '#3B3C45 !important'
    },
    in: {
      border: '2px solid #000'
    }
  })
);

export default observer(Question);
